"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonBoxCallCar = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var selectors_1 = require("../../redux/selectors");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var transformPhoneNumber_1 = require("../../helpers/transformPhoneNumber");
var ButtonBoxCallCar_module_scss_1 = __importDefault(require("./ButtonBoxCallCar.module.scss"));
var ButtonBoxCallCar = function (_a) {
    var extraStyles = _a.extraStyles;
    var dispatch = (0, react_redux_1.useDispatch)();
    var contacts = (0, react_redux_1.useSelector)(selectors_1.contactsSelector).contacts;
    var openModalCallback = function () { return dispatch((0, modalSlice_1.openModal)('callback')); };
    return (react_1.default.createElement("div", { className: ButtonBoxCallCar_module_scss_1.default.call_box, style: extraStyles },
        react_1.default.createElement("a", { className: ButtonBoxCallCar_module_scss_1.default.call_box__link, href: "tel: +".concat(contacts.phone) }, (0, transformPhoneNumber_1.transformPhoneNumber)(contacts.phone)),
        react_1.default.createElement("button", { className: ButtonBoxCallCar_module_scss_1.default.call_box__button, type: "button", onClick: openModalCallback }, "\u041F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\u044C")));
};
exports.ButtonBoxCallCar = ButtonBoxCallCar;
